import React, { useContext } from "react";
import { ClientContext } from "../../../store/context";
import { TextField } from "@mui/material";

function ReservationSummary() {
  const {
    formBody,
    paymentMethod,
    setReservationComments,
    reservationComments,
  } = useContext(ClientContext);
  const displayRow = (text, value) => (
    <div style={{ display: "flex", flexDirection: "row" }}>
      <span>{text} : </span>
      <span> {value}</span>
    </div>
  );
  return (
    <div style={{ padding: "10px" }}>
      <h2>Summary</h2>
      <div style={{ paddingLeft: "10px" }}>
        <h3>Personal Details</h3>
        <div style={{ paddingLeft: "10px" }}>
          {displayRow("Name", formBody.customerName)}
          {displayRow("Surname", formBody.customerLastName)}
          {displayRow("E-mail", formBody.customerMail)}
          {displayRow("Phone", formBody.customerPhone)}
          {displayRow("Address", formBody.customerAddress)}
          {displayRow("Country", formBody.customerCountry)}
          {displayRow("Flight Number", formBody.flightNumber)}
        </div>
        <h3>Payment Method</h3>
        <div style={{ paddingLeft: "10px" }}>
          {displayRow("Payment Method", paymentMethod)}
        </div>
        <h3>Comments</h3>
        <div style={{ paddingLeft: "10px" }}>
          <TextField
            sx={{ width: "100%" }}
            multiline
            rows={3}
            maxRows={4}
            value={reservationComments}
            onChange={(e) => setReservationComments(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
}

export default ReservationSummary;
